// @ts-nocheck
// W14a — Reusable empty state for lists/tables.
// Use sempre que uma listagem puder vir vazia, pra não dar a impressão de erro de API.
//
// Uso:
//   <EmptyState label="Nenhum usuário cadastrado" />
//   <EmptyState label="Nenhum encontrado" submessage="Tente outro filtro" action={<Button>Limpar</Button>} />
import { Center, Stack, Text } from "@mantine/core";
import { IconInbox, type Icon } from "@tabler/icons-react";
import type { ReactNode } from "react";

export interface EmptyStateProps {
  label: string;
  submessage?: string;
  icon?: typeof Icon;
  py?: string | number;
  mih?: string | number;
  /** Slot de ação (ex.: botão "Limpar busca"). Renderiza abaixo do submessage com espaçamento. */
  action?: ReactNode;
}

export default function EmptyState({
  label,
  submessage,
  icon: Icon = IconInbox,
  py = "xl",
  mih,
  action,
}: EmptyStateProps) {
  return (
    <Center py={py} mih={mih}>
      <Stack gap={4} align="center">
        <Icon size={32} color="var(--mantine-color-gray-5)" />
        <Text size="sm" c="dimmed">
          {label}
        </Text>
        {submessage && (
          <Text size="xs" c="dimmed">
            {submessage}
          </Text>
        )}
        {action && <div style={{ marginTop: 8 }}>{action}</div>}
      </Stack>
    </Center>
  );
}
